import React, { useEffect, useMemo, useState } from 'react'
import {
  getEmployee,
  getInitConfig,
  updateEmployeeQuery
} from './services'
import { useNavigate } from 'react-router'
import { getRecords } from './services/record-services'
import { get } from 'lodash'
import { RecordStatus } from '@shared/utils/constants'

export const AppContext = React.createContext({})

function Context(props) {

  const [tokenId, setTokenId] = useState(null)
  const [babysittingModes, setBabysittingModes] = useState(null)
  const [benefitAmounts, setBenefitAmounts] = useState(null)
  const [employee, setEmployee] = useState(null)
  const [originalEmployee, setOriginalEmployee] = useState(null)
  const [childrenIds, setChildrenIds] = useState({})
  const [attachmentConfig, setAttachmentConfig] = useState()
  const [recordAttachConfig, setRecordAttachConfig] = useState(null)
  const [familySituations, setFamilySituations] = useState({})
  const [ageCategories, setAgeCategories] = useState({})
  const [restrictionSFT, setResctrictionSFT] = useState(true)

  const [declarationAttachConfig, setDeclarationAttachConfig] = useState(null)
  const [records, setRecords] = useState(null)
  const [flagRecordsUpdate, setFlagRecordsUpdate] = useState(false)

  const newTokenId = useMemo(() => localStorage.getItem('jwt-token'),[])

  const navigate = useNavigate()

  const employeeFields = `ratpId
            firstName
            lastName
            nbChildren
            address {
              city
              postcode
            }
            children {
              id
              firstName
              lastName
              dateOfBirth
              ageCategory
              expired
              specialContract
            }
            singleParent
            situationFamily
            phoneNumber
            email
            consentRemoved
          `

  const recordFields = `
            _id
            status
            babysittingMode
            child {
              id
              firstName
            }
            temporaryRightDate
          `

  useEffect(() => {
      setTokenId(newTokenId)
  }, [newTokenId])

  useEffect(() => {
    const fetch = async () => {
      const result = await getRecords(recordFields)
      setRecords(result.data.getRecords)
    }
      fetch()
  }, [flagRecordsUpdate])

  useEffect(()=>{
    if(employee && records){
      const hasRecordValidated = records.filter(r=>r.status === RecordStatus.VALIDATED).length > 0
      if(!get(employee, 'email') && hasRecordValidated){
        navigate('/contactInformation')
      }
    }
  },[employee,records])

  useEffect(() => {
    const getEmployeeInfo = async () => {
      if (tokenId) {
        const result = await getEmployee(employeeFields)
        if (result && result.data && result.data.getEmployee) {

          const connectedEmployee = result.data.getEmployee

          // If the email has already been saved once, then the user does not
          // need to specify it again when depositing a new file :
          if (connectedEmployee.email) {
            connectedEmployee.confirmEmail = connectedEmployee.email
          }

          if(connectedEmployee.children) {
            const ids = {}
            connectedEmployee.children.forEach(child => ids[child.id] = true)
            setChildrenIds(ids)
          }

          setEmployee(connectedEmployee)
          setOriginalEmployee(connectedEmployee)
        }
      }
    }
    if (!employee) {
      getEmployeeInfo()
    }
  }, [tokenId])

  useEffect(() => {
    if (employee && employee.consentRemoved) {
      navigate('/consent')
    }
  }, [employee])

  useEffect(() => {
    const fetch = async () => {
      const result = await getInitConfig()
      const singleParentList = result['situation.family.single.parent']
      const singleParentSet = new Set()
      for (const familySituationsSingleParent of singleParentList) {
        singleParentSet.add(familySituationsSingleParent.key)
      }
      const familySituation = result['situation.family']
      Object.keys(familySituation).map(familySituationCode => {
        familySituation[familySituationCode].isSingleParent = singleParentSet.has(familySituationCode)
      })
      setFamilySituations(familySituation)
      setAgeCategories(result['age.categories'])
      setBabysittingModes(result['benefit.babysitting.mode'])
      setResctrictionSFT(result['sft.restriction'])
      setAttachmentConfig(result['attach.config'])
      setRecordAttachConfig(result['record.attachment'])
      setDeclarationAttachConfig(result['declaration.attachment'])
      setBenefitAmounts(result['benefit.amount'])
    }
    fetch()
  }, [])

  const updateEmployeeContact = (employee) => {

    const { email, phoneNumber } = employee
    const employeeInput = `
        email: "${ email }"
        ${ phoneNumber ? `phoneNumber: "${ phoneNumber }"` : `phoneNumber: ""` }
      `

    const result = updateEmployeeQuery(employeeInput, employeeFields)
    if (result && result.data && result.data.updateEmployee) {
      const connectedEmployee = result.data.updateEmployee
      setEmployee(connectedEmployee)
      setOriginalEmployee(connectedEmployee)
    }
    return result
 }

  const isChildActive = (childId) => {
    return !restrictionSFT || (childrenIds && childrenIds[childId])
  }

  const myContext = {
    tokenId,
    setTokenId,
    employee,
    setEmployee,
    originalEmployee,
    setOriginalEmployee,
    childrenIds,
    updateEmployeeContact,
    records,
    attachmentConfig,
    recordAttachConfig,
    ageCategories,
    babysittingModes,
    familySituations,
    declarationAttachConfig,
    benefitAmounts,
    flagRecordsUpdate,
    setFlagRecordsUpdate,
    isChildActive
  }
  return <AppContext.Provider value={ myContext }>
    { props.children }
  </AppContext.Provider>
}


export default Context
